const debounceList = {};

export const debounceCallback = (callback, args, debounceName, delay = 800) => {
  const name = debounceName ?? "default";

  if (debounceList[name]) {
    clearTimeout(debounceList[name]);
  }

  debounceList[name] = setTimeout(() => callback(...(args ?? [])), delay);
};


export const cancelDebounceCallback = (debounceName) => {
  const name = debounceName ?? "default";

  if (debounceList[name]) {
    clearTimeout(debounceList[name]);
    delete debounceList[name];
  }
};